import type { IImageScrollStrategy } from '@/engine/app/modules/images/interfaces.ts';
import type { PointsSwitcherController } from '@/components/PointsSwitcher/PointsSwitcher.controller.ts';
import type { IObjectViewModel } from '@/engine/app/interfaces.ts';

export class ImagePointToPointRotationScrollStrategy implements IImageScrollStrategy {
  private readonly _vm: IObjectViewModel | undefined;

  private _controller: PointsSwitcherController;

  public constructor(controller: PointsSwitcherController) {
    this._controller = controller;
    this._vm = this._controller.selectedSplineViewModel;
  }

  public handleScroll(delta: number): void {
    if (!this._vm) {
      throw new Error('Selected spline VM should be defined');
    }

    if (delta > 0) this._controller.nextPoint(this._vm);
    if (delta < 0) this._controller.prevPoint(this._vm);
  }
}
